import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';
import { notification } from 'antd';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { updateBuilding } from 'services/api';
import type { BuildingFormValues, EditBuildingModalProps } from '../types';
import { BuildingFooter } from '../Footer/BuildingFooter';
import { BuildingForm } from '../../Form/BuildingForm';

export const EditBuildingModal = ({
  selectedBuilding,
  visible,
  hide,
  onItemEdit,
}: EditBuildingModalProps) => {
  const [form] = useForm<BuildingFormValues>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedBuilding) {
      form.setFieldsValue({ ...selectedBuilding });
    }
  }, [selectedBuilding]);

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      updateBuilding(selectedBuilding!.id, values)
        .then(() => {
          hideModal();
          onItemEdit();
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось обновить здание' });
          throw error;
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  const footer = (
    <BuildingFooter onSubmit={onSubmit} hideModal={hideModal} title="Редактировать здание" />
  );
  const content = <BuildingForm form={form} isEdit />;

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      maskClosable={false}
      title={selectedBuilding?.name}
    />
  );
};
